import { Component, OnInit } from '@angular/core';
import { DomainType } from '@app/core/models/domain-type';
import { EndUserContextService } from '@app/shared/services/context/end-user-context.service';
import { Authorization } from '@business/end-user/models/authorization';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'portal-end-user-sub-nav',
  templateUrl: './end-user-sub-nav.component.html',
  host: {
    class: 'sub-nav-container',
  },
  standalone: false,
})
export class EndUserSubNavComponent implements OnInit {
  public hasAcd: boolean = false;
  public hasCallCenter: boolean = false;
  public hasDevice: boolean = false;

  public isCallCenterSupervisor: boolean = false;
  public isNotResidentialUser: boolean = false;
  public isResidentialUser: boolean = false;

  public loading: boolean = true;

  constructor(private endUserContextService: EndUserContextService) {}

  ngOnInit(): void {
    combineLatest([
      this.endUserContextService.endUser.data$,
      this.endUserContextService.callCenter.data$,
      this.endUserContextService.enterprise$,
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([endUser, callCenter, enterprise]) => {
        this.hasAcd = endUser.isAcdQueueAgent ?? false;
        this.hasCallCenter = endUser.isCallCenterAgent ?? false;
        this.hasDevice = endUser.user?.auth === Authorization.FULL;

        this.isCallCenterSupervisor = callCenter?.isSupervisor === true;

        if (enterprise != null) {
          this.isResidentialUser = enterprise.c5.type === DomainType.RESIDENTIAL;
        } else if (endUser != null) {
          this.isResidentialUser = endUser.user.domainType === DomainType.RESIDENTIAL;
        }

        this.isNotResidentialUser = !this.isResidentialUser;

        this.loading = false;
      });
  }
}
